var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.252V16.342C13.5949 16.022 12.6263 15.9239 11.6754 16.0558C10.7245 16.1877 9.8192 16.5459 9.03543 17.1002C8.25166 17.6545 7.61234 18.3888 7.17116 19.2414C6.72998 20.094 6.49982 21.04 6.5 22L4.5 21.999C4.49969 20.7779 4.77892 19.5729 5.3163 18.4764C5.85368 17.3799 6.63494 16.4209 7.60022 15.673C8.5655 14.9251 9.68918 14.4081 10.8852 14.1616C12.0811 13.9152 13.3177 13.9457 14.5 14.251V14.252ZM12.5 13C9.185 13 6.5 10.315 6.5 7C6.5 3.685 9.185 1 12.5 1C15.815 1 18.5 3.685 18.5 7C18.5 10.315 15.815 13 12.5 13ZM12.5 11C14.71 11 16.5 9.21 16.5 7C16.5 4.79 14.71 3 12.5 3C10.29 3 8.5 4.79 8.5 7C8.5 9.21 10.29 11 12.5 11ZM18.5 17V14H20.5V17H23.5V19H20.5V22H18.5V19H15.5V17H18.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContact);
export default __webpack_public_path__ + "static/media/addContact.bfb8670224d6aa0775f8f56f00ddc583.svg";
export { ForwardRef as ReactComponent };